// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { Tag } from "antd";
import { NewsStatusTagProps } from "../../../types/NewsTypes";
import { NEWS_WORKFLOW_STATUS } from "../../../../utils/Constant";

const NewsStatusTag: React.FunctionComponent<NewsStatusTagProps> = (
  props: NewsStatusTagProps
) => {
  const { status } = props;

  return (
    <Tag color={NEWS_WORKFLOW_STATUS[status].color}>
      {NEWS_WORKFLOW_STATUS[status].label}
    </Tag>
  );
};

export default NewsStatusTag;
